import React from "react";
import "./App.css";
import Router from "./router";
import ErrorContext from "./component/Context/ErrorContext";
import Alert from "./component/Alert";

function App() {
  return (
    <div className="App">
      <ErrorContext>
        <Alert />
        <Router />
      </ErrorContext>
    </div>
  );
}

export default App;
